module.exports = __webpack_public_path__ + "static/media/bg-profile.9343b813.jpg";